window.addEventListener('load', initRichtextToTabs);

function initRichtextToTabs() {
  const productTabsContainer = document.querySelector('[data-product_tabs_container]');
  if (!productTabsContainer) return;
  const richtextContainer = productTabsContainer.querySelector('.metafield-rich_text_field');
  if (!richtextContainer) return;

  const tabsOutput = productTabsContainer.querySelector('[data-tabs]');
  const tabTemplate = productTabsContainer.querySelector('[data-tab_template]');
  if (!tabsOutput || !tabTemplate) return;

  let headingIndex = -1;
  const productTabs = [];
  for (const element of richtextContainer.children) {
    if (element.nodeName.toLowerCase() === 'h1') {
      productTabs.push({ header: element.textContent, content: [] });
      headingIndex++;
      continue;
    }
    if (headingIndex < 0) continue;
    productTabs[headingIndex].content.push(element);
  }
  productTabs.forEach((tab) => renderTab(tab, tabTemplate, tabsOutput));

  //productTabsContainer.removeChild(richtextContainer);
  productTabsContainer.removeChild(tabTemplate);
}

function renderTab(data, template, target) {
  const tab = template.cloneNode(true);
  const header = tab.querySelector('[data-header]');
  const content = tab.querySelector('[data-content]');
  if (!header || !content) return;

  header.textContent = data.header;
  data.content.forEach((element) => content.appendChild(element));

  tab.classList.remove(tab.dataset.hidden);
  tab.removeAttribute('data-tab_template');
  tab.removeAttribute('data-hidden');
  header.removeAttribute('data-header');
  content.removeAttribute('data-content');

  addTabEvent(tab);
  target.appendChild(tab);

  if (data.header.toLowerCase() === 'full description') {
    const headerLabel = tab.querySelector('.accordion-header');
    headerLabel.click();
  }
}

function addTabEvent(tab) {
  const header = tab.querySelector('.accordion-header');
  const content = tab.querySelector('.accordion-content');
  const expandMore = tab.querySelector('.expand-more');
  const expandLess = tab.querySelector('.expand-less');
  header.addEventListener('click', function (event) {
    if (tab.classList.contains('active')) {
      content.classList.add('h-0');
      tab.classList.remove('active');
      expandMore.classList.toggle('hidden');
      expandLess.classList.toggle('hidden');
      return;
    }
    content.classList.remove('h-0');
    tab.classList.add('active');
    expandMore.classList.toggle('hidden');
    expandLess.classList.toggle('hidden');
  });
}
